import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "112",
  height: "112",
  viewBox: "0 0 112 112",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M112 0H0V112H112V0Z",
      fill: "#D7DBF7"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M30.9399 27.3933V84.6067C30.9035 85.4702 31.1077 86.3269 31.5296 87.0812C31.9515 87.8355 32.5746 88.4579 33.3295 88.8789C34.0843 89.2998 34.9413 89.5029 35.8048 89.4654C36.6683 89.428 37.5044 89.1514 38.2199 88.6667L81.1533 60.06C81.7885 59.6331 82.309 59.0565 82.6689 58.3811C83.0288 57.7056 83.217 56.952 83.217 56.1867C83.217 55.4213 83.0288 54.6677 82.6689 53.9922C82.309 53.3168 81.7885 52.7402 81.1533 52.3133L38.2199 23.3333C37.5044 22.8485 36.6683 22.572 35.8048 22.5345C34.9413 22.4971 34.0843 22.7001 33.3295 23.1211C32.5746 23.5421 31.9515 24.1644 31.5296 24.9188C31.1077 25.6731 30.9035 26.5298 30.9399 27.3933Z",
      fill: "#151F6D"
    }, null, -1)
  ])))
}
export default { render: render }